<div class="wx-spacer" />

<style>
	.wx-spacer {
		flex: 1 1 auto;
	}

</style>
